export { default } from "./DrilldownFactorChart";
